<template>
    <div class="box">
      <TopTabs :list="this.$nav6"/>
      <div class="video-box">
          <video class="myVideo"
                autoplay="autoplay"
                muted
                controls
                :src="$route.query.url" type="video/mp4"
                >
          </video>
      </div>
    </div>
</template>

<script>
import TopTabs from '@/components/topTabs_h5/index'

export default {
  name: 'vDetails',
  components: { TopTabs },
  props: {},
  data () {
    return {
      isMaxScreen: true
    }
  },
  computed: {
  },
  watch: {
    screenWidth: function (val) {
      // 监听屏幕宽度变化
      // console.log("val",val)
      this.isMaxScreen = val > 850
      // alert('ppp')
    }
  },
  created () {
  },
  mounted () {
    this.isMaxScreen = document.body.clientWidth > 850
    window.addEventListener('resize', () => {
      console.log('外部', document.body.clientWidth)
      this.isMaxScreen = document.body.clientWidth > 850
      // console.log("this.isMaxScreen",this.isMaxScreen)
      // console.log(99999999999999999999999999999)
    })
  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
 $wh: 11.7333vw;
 $vwh: 100%;
 $tf: 50%;
  .box{
    min-height: 86.5vh;
  .video-box{
      width: 100%;
      height:64vw;
      padding: 4.26vw;
      position: relative;
      cursor: pointer;
      margin-bottom: 14px;
       .myVideo{
          width: $vwh;
          height: $vwh;
          object-fit: cover;
        }
        .video_play {
          position: absolute;
          top: $tf;
          left: $tf;
          transform: translate(-$tf, -$tf);
          width: $wh;
          height: $wh;
          border-radius: $tf;
          background-size: $vwh;
          z-index: 99;

        }
  }
}

</style>
